import { render, staticRenderFns } from "./shipping-audit-queue-details.vue?vue&type=template&id=9984994c&scoped=true&"
import script from "./js/shipping-audit-queue-details.js?vue&type=script&lang=js&"
export * from "./js/shipping-audit-queue-details.js?vue&type=script&lang=js&"
import style0 from "./shipping-audit-queue-details.vue?vue&type=style&index=0&id=9984994c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9984994c",
  null
  
)

export default component.exports